const SearchData = [
  {
    title: "Home",
    link: "/",
  },
  {
    title: "About Us",
    link: "/about-us",
  },
  {
    title: "Services",
    link: "/services",
  },
  {
    title: "Expertise",
    link: "/expertise",
  },
  {
    title: "Resources",
    link: "/resources",
  },
  {
    title: "Case Studies & Stories",
    link: "/case-studies",
    from: "Resources",
  },
  {
    title: "Blogs",
    link: "/blogs",
    from: "Resources",
  },
  {
    title: "How We Work",
    link: "/how-we-work",
  },
  {
    title: "Careers",
    link: "/careers",
  },
  {
    title: "Contact",
    link: "/contact",
  },
  {
    title: "Company Profile",
    link: "/about-us#company-profile",
    from: "About Us",
  },
  {
    title: "Our Journey",
    link: "/about-us#our-journey",
    from: "About Us",
  },
  {
    title: "Mission Vision",
    link: "/contact",
    from: "about-us#mission-vision",
  },
  {
    title: "Why Technocrom",
    link: "/about-us#why-technocrom",
    from: "About Us",
  },
  {
    title: "Life At Technocrom",
    link: "/about-us#life-at-technocrom",
    from: "About Us",
  },
  {
    title: "Project Based",
    link: "/how-we-work#project-based",
    from: "How We Work",
  },
  {
    title: "Team Augmentation Model",
    link: "/how-we-work#team-augmentation-model",
    from: "How We Work",
  },
  {
    title: "Digital Testing",
    link: "/digital-testing",
    from: "Services",
  },
  {
    title: "Test Automation",
    link: "/test-automation",
    from: "Services",
  },
  {
    title: "Security Testing",
    link: "/security-testing",
    from: "Services",
  },
  {
    title: "Performance Testing",
    link: "/performance-testing",
    from: "Services",
  },
  {
    title: "Manual Testing",
    link: "/manual-testing",
    from: "Services",
  },
  {
    title: "Test Advisory",
    link: "/test-advisory",
    from: "Services",
  },
  {
    title: "Web Development",
    link: "/web-development",
    from: "Services",
  },
  {
    title: "Mobile Development",
    link: "/app-development",
    from: "Services",
  },
  {
    title: "Health Care",
    link: "/health-care",
    from: "Expertise",
  },
  {
    title: "Point Of Sale (POS)",
    link: "/point-of-sale",
    from: "Expertise",
  },
  {
    title: "Gaming Apps",
    link: "/gaming-apps",
    from: "Expertise",
  },
  {
    title: "Banking",
    link: "/banking",
    from: "Expertise",
  },
  {
    title: "Ecommerce",
    link: "/ecommerce",
    from: "Expertise",
  },
];

export default SearchData;
